export const main = {
  consumer_notice: 'Ben je een consument die eten wil bestellen? Bezoek dan onze marktplaats',
  consumer_notice_mobile: 'Consument die wil bestellen?',
  order_now: 'Bestel nu',
  order_food: 'Eten bestellen',

  logo_alt: 'Bistroo',
  login_text: 'Log in',
  start_free_text: 'Start gratis',

  actions: {
    create_your_shop: 'Maak je webshop',
    product_demo: 'Product demo'
  },

  menu: {
    home: {
      text: 'Home',
    },
    products: {
      text: 'Producten',
      submenu: {
        manager: {
          text: 'Bistroo Manager',
          subtext: 'Alle tools volledig in eigen beheer'
        },
        qr: {
          text: 'Bistroo QR',
          subtext: 'Een kostenefficiënt tafelbestelproces'
        },
        webshop: {
          text: 'Bistroo Webshop',
          subtext: 'De webshop voor jou restaurant'
        },
        pos: {
          text: 'Bistroo POS device',
          subtext: 'Plug & play bestellen en printen'
        },
        page: {
          text: 'Bistroo Page',
          subtext: 'Maak binnen minuten een website'
        }
      }
    },
    prices: {
      text: 'Prijzen',
    },
    cases: {
      text: 'Cases',
      submenu: {
        cafetaria: {
          text: 'Cafetaria D\'n Boom',
          subtext: 'Hoe Bistroo hielp de omzet te vergroten.',
        },
        grillroom: {
          text: 'Grillroom Instanbul',
          subtext: 'Eindelijk een eerlijk verdienmodel.',
        },
        sushi: {
          text: 'Sushi De wethouder',
          subtext: 'Een partner die we 24/7 kunnen vertrouwen.'
        },
        italian: {
          text: 'Italiaan Il Municipio',
          subtext: 'Een nieuwe oplossing en mogelijkheden.'
        },
        lunchroom: {
          text: 'Lunchroom Two-B',
          subtext: 'We hebben veel tijd en frustratie bespaard.'
        },
      }
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: {
          text: 'Helpcentrum',
          subtext: 'Alle informatie die je nodig hebt',
        },
        integrations: {
          text: 'Integraties',
          subtext: 'Onze partnerintegraties',
        },
        downloads: {
          text: 'Downloads',
          subtext: 'De laatste app-updates',
        },
        articles: {
          text: 'Artikelen',
          subtext: 'Laatste branche-updates',
        },
        faq: {
          text: 'FAQ',
          subtext: 'Meestgestelde vragen',
        },
        support: {
          text: 'Klantenservice',
          subtext: 'We helpen je graag verder',
        },
        contact: {
          text: 'Contact',
          subtext: 'We helpen je graag verder',
        },
      }
    }
  },
  cta_block: {
    open_your_webshop_today: 'Open vandaag je shop.',
    its_free: 'Het is gratis!',
    start_generating_more_orders: 'Genereer binnen enkele minuten je eerste bestelling',
    get_started_for_free: 'Start gratis'
  },
  footer: {
    general: 'Algemeen',
    products: 'Producten',
    cases: 'Cases',
    info: 'Informatie'
  }
}